/*
 *
*/
import Vue from 'vue';
import PortalPlugin from './plugins/portal-plugin';
import App from './App.vue';
import store from './store/index';
import "./i18n/index";
import { Keys } from "./plugins/globalConstants";
import router from './routes/router';
import CountryFlag from 'vue-country-flag';
import Axios from 'axios';
import Emitter from 'tiny-emitter';
// importing the helper
import interceptorsSetup from './helpers/interceptors'
Vue.use(PortalPlugin);
Vue.use(Keys);
Vue.component('country-flag', CountryFlag);
Vue.prototype.$http = Axios;
Vue.prototype.$msalInstance = {};
Vue.prototype.$emitter = new Emitter();

interceptorsSetup();

new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
});
